import { type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { useBasket } from './useBasket';
import type { Basket, Shipment } from './model';

export const useAddShipment = (): UseMutationResult<unknown, unknown, Shipment> => {
    const { data } = useBasket();
    const queryClient = useQueryClient();

    return useBffPostMutation<Basket, Shipment>(`/baskets/${data?.basketId}/shipments`, [], [], {
        basketCustomerId: data?.customerInfo?.customerId,
        onSuccess: (basket) => {
            queryClient.setQueryData([BffQueryKey.BASKET], basket);
        },
    });
};
